import { configureStore } from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from './services/auth';
import authSlice, { AuthInitialStates } from './authSlice';
import { projectApi } from './services/project';
import { teamsApi } from './services/teams';
import { checklistApi } from './services/checklists';
import { inspectionApi } from './services/inspection';
import { observationApi } from './services/observation';
import { incidentApi } from './services/incident';
import { dashboardApi } from './services/dashboard';
import projectSlice, { ProjectInitialStates } from './projectSlice';
import conductInspectionSlice, {
  ConductInspectionInitialStates,
} from './conductInspectionSlice';
import checklistSlice, { ChecklistInitialStates } from './checklistSlice';

export interface RootStates {
  auth: AuthInitialStates;
  project: ProjectInitialStates;
  conductInspection: ConductInspectionInitialStates;
  checklist: ChecklistInitialStates;
}

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [authApi.reducerPath]: authApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    [teamsApi.reducerPath]: teamsApi.reducer,
    [checklistApi.reducerPath]: checklistApi.reducer,
    [inspectionApi.reducerPath]: inspectionApi.reducer,
    [observationApi.reducerPath]: observationApi.reducer,
    [incidentApi.reducerPath]: incidentApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    auth: authSlice,
    project: projectSlice,
    conductInspection: conductInspectionSlice,
    checklist: checklistSlice,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      projectApi.middleware,
      teamsApi.middleware,
      checklistApi.middleware,
      inspectionApi.middleware,
      observationApi.middleware,
      incidentApi.middleware,
      dashboardApi.middleware,
    ),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
